module.exports = __webpack_public_path__ + "img/page14.9d20d657.gif";